import * as options from 'vfm/options/basic'
import {
  usstates
} from 'us-states/us-states'
// import email1 from 'vfm/email1.html'

export const meta = {
  form_name: 'Accommodation Request',
  poc_name1: 'South Dakota Mines',
  //poc_email1: 'Vickie.Bender@sdsmt.edu',
  poc_email1: 'amanda.lopez@sdsmt.edu, disabilityservices@sdsmt.edu',
  poc_email_dept: 'disabilityservices@sdsmt.edu',
  poc_dept1: 'South Dakota Mines Student Services',

  root: 'student-services',
  sub: 'services-request',
  closed: false,
  
  debugtemplate: false,
  debugdata: false 
}

// const optionsarray = [ 
//   { text : '', value: '' },
//   { text : '', value: '' }
// ]

const status = [
  { text: 'Applying for Admission or Accepted for Next Semester', value: 'Applying/Accepted' },
  { text: 'Freshman', value: 'Freshman' },
  { text: 'Sophomore', value: 'Sophomore' },
  { text: 'Junior', value: 'Junior' },
  { text: 'Senior', value: 'Senior' },
  { text: 'Graduate', value: 'Graduate' },
]

const conditions = [
  { text: 'Physical Disability', value: 'Physical Disability' },
  { text: 'Intellectual/Learning Disability', value: 'Intellectual/Learning Disability' },
  { text: 'Psychiatric Disability', value: 'Psychiatric Disability' },
  { text: 'Visual Impairment', value: 'Visual Impairment' },
  { text: 'Hearing Impairment', value: 'Hearing Impairment' },
  { text: 'Neurological Disability', value: 'Neurological Disability' },
]

const equip = [
  { text: 'Cane', value: 'Cane' },
  { text: 'Lap Board', value: 'Lap Board' },
  { text: 'Headpointer', value: 'Headpointer' },
  { text: 'Transfer Equipment', value: 'Transfer Equipment' },
  { text: 'Laptop Computer', value: 'Laptop Computer' },
  { text: 'Magnification Equipment', value: 'Magnification Equipment' },
  { text: 'Speech Communication Device', value: 'Speech Communication Device' },
  { text: 'Crutches', value: 'Crutches' },
  { text: 'Hand Splints', value: 'Hand Splints' },
  { text: 'Lift-Equipped Van', value: 'Lift-Equipped Van' },
  { text: 'Assistive Speech Device', value: 'Assistive Speech Device' },
  { text: 'Audio Recorder', value: 'Audio Recorder' },
  { text: 'Talking Equipment', value: 'Talking Equipment' },
  { text: 'Power Wheelchair', value: 'Power Wheelchair' },
  { text: 'Manual Wheelchair', value: 'Manual Wheelchair' },
  { text: 'Communication Board', value: 'Communication Board' },
] 

const reside = [
  { text: 'On Campus', value: 'On Campus' },
  { text: 'Own House or Apartment', value: 'Own House or Apartment' },
  { text: 'House or Apartment Shared with Room Mates', value: 'House or Apartment Shared with Room Mates' },
  { text: 'With Family', value: 'With Family' },
  { text: 'Fraternity or Sorority House', value: 'Fraternity or Sorority House' },
]

const services = [ 
  { text : 'Test Taking Accommodations', value: 'Testing Test Taking Accommodations' },
  { text : 'Sign Language Interpreter', value: 'Sign Language Interpreter' },
  { text : 'Note Taker or Scribe', value: 'Note Taker or Scribe' },
  { text : 'Assistive Listening Device', value: 'Assistive Listening Device' },
  { text : 'Special Parking Permit', value: 'Special Parking Permit' },
  { text : 'Wheelchair Storage', value: 'Wheelchair Storage' },
//  { text : 'Accessible Residence Hall Accommodations', value: 'Accessible Residence Hall Accommodations' },
  { text : 'Written Materials in Alternative Formats', value: 'Written Materials in Alternative Formats' },
//  { text : 'Audio Textbooks', value: 'Audio Textbooks' },
  { text : 'Residential/Housing Accommodations', value: 'Residential/Housing Accommodations' }
]

const addText = '+ Add'
const hideText = 'x Cancel'

export const intro = {
  title: meta.form_name,
  subtitle: '',
  desc: '<p>Please provide all information requested to enable the university to best meet your needs. If you need assistance completing this form, please contact Disability Coordinator Amanda Lopez at <a href="tel:605-394-2533">605-394-2533</a> or at <a href="mailto:disabilityservices@sdsmt.edu">disabilityservices@sdsmt.edu</a>.</p>'
};

const email1 = {
  from_name: meta.poc_dept1,
  from: 'user',
  to: meta.poc_email1,
  subject: meta.form_name + ' Submission ',
  body: 'body1'
};

const email2 = {
  from_name: meta.poc_dept1,
  from: meta.poc_email_dept,
  to: 'self',
  subject: meta.form_name + ' Submission ',
  body: 'body2'
};

export const results = {
  miners: '',
  post: 'Y',
  enroll: '',
  stamp: '',
  confirm: 'https://interact.sdsmt.edu/' + meta.root + '/' + meta.sub + '-confirm.asp',
  emails: [email1, email2],
  action: '',
  csv_files: [{
    omit: [''],
    path: meta.root + '/',
    file: meta.sub + '.csv'
  }]
};

export const path_hash = '';

export const terms = {
     show: true,
     title: 'All students are required to provide medical or other appropriate diagnostic evaluation of their disability.',
     label: 'I have read and understand the above information.',
     text: '<p>Documentation provided should include, but may not be limited to:<ul><li> Demonstration of comprehensive assessments and evaluations, using adult scales, conducted by an appropriately credentialed professional.</li><li> Demonstration of the evaluator having ruled out alternative explanations and diagnoses for presenting problems.</li><li>Clear statement of the current impact of the disability upon major life functions and the functional limitations in an education environment.</li><li>Background information including pertinent and relevant histories – academic, family, developmental, medical, psychosocial, treatment, therapy, interventions, and accommodations.</li><li>Specific diagnoses with accommodation recommendations.</li><li>Signature and contact information of diagnostician including mailing address, telephone number and email address. </li></ul></p>',
     data: ''
};

export const items = {
  // vfm_field_guide: {
  //   section_header: '2. List your summer classes, start dates, and credits:',
  //   group: 'start',
  //   group_label: 'Class 1',
  //   name: 'NameAndIDs',
  //   data: '',
  //   label: 'What should the label say?',
  //   help: '',
  //   type: 'select, checkbox, checkboxgroup, textarea, currency, radio, auto, link, text, date',
  //   init: {
  //     options: optionsarray
  //   },
  //   reqs: 'required',
  //   show: true,
  //   ctrl: [{
  //     opener: location_type[0],
  //     targets: ['vfm_room_number']
  //   },{
  //     opener: location_type[1],
  //     targets: ['vfm_floor', 'vfm_area']
  //     }
  //   ],
  // },
  
  vfm_name: {
      name: 'Name',
      data: '',
      label: 'Name',
      help: '',
      type: 'text',
      init: {
        placeholder: ' ',
        options: ''
      },
      reqs: 'required',
      show: true
    },
    
  vfm_dob: {
      name: 'DOB',
      data: '',
      label: 'Date of Birth',
      help: '',
      type: 'date',
      init: {
        placeholder: ' ',
        options: ''
      },
      reqs: 'required',
      show: true
    },  
    
    vfm_sid: {
      name: 'StudentID',
      data: '',
      label: 'Student ID',
      help: '',
      type: 'text',
      init: {
        placeholder: ' ',
        options: ''
      },
      reqs: 'required',
      show: true
    }, 
    
    vfm_addr1: {
      name: 'Address1',
      data: '',
      label: 'Current Address',
      help: '',
      type: 'text',
      init: {
        placeholder: ' ',
        options: ''
      },
      reqs: 'required',
      show: true
    },
    
    vfm_addr2: {
      name: 'Address2',
      data: '',
      label: 'Current Address Line 2',
      help: '',
      type: 'text',
      init: {
        placeholder: ' ',
        options: ''
      },
      reqs: '',
      show: true
    },
    
    vfm_city: {
      name: 'city',
      data: '',
      label: 'City',
      help: '',
      type: 'text',
      init: {
        placeholder: ' ',
        options: ''
      },
      reqs: 'required',
      show: true
    },
    
    vfm_state: {
      name: 'State',
      data: '',
      label: 'State',
      help: '',
      type: 'select',
      init: {
        placeholder: ' ',
        options: usstates
      },
      reqs: 'required',
      show: true
    },
    
    vfm_zip: {
      name: 'zip',
      data: '',
      label: 'Zip Code',
      help: '',
      type: 'text',
      init: {
        placeholder: ' ',
        options: ''
      },
      reqs: 'required',
      show: true
    },
  
    vfm_phone: {
      name: 'phone',
      data: '',
      label: 'Phone Number',
      help: '',
      type: 'text',
      init: {
        placeholder: ' ',
        options: ''
      },
      reqs: 'required',
      show: true
    },
    
    vfm_email: {
      name: 'Email',
      data: '',
      label: 'Email Address',
      help: '',
      type: 'text',
      init: {
        placeholder: ' ',
        options: ''
      },
      reqs: 'email|required',
      show: true,
    },
    
    vfm_major: {
      name: 'Major',
      data: '',
      label: 'Major/Program of Study',
      help: '',
      type: 'text',
      init: {
        placeholder: ' ',
        options: ''
      },
      reqs: 'required',
      show: true,
    },
    
    vfm_status: {
      name: 'Status',
      data: [],
      // section_header: '2. List your summer classes, start dates, and credits:',
      // group: 'start',
      // group_label: 'Class 1',
      label: 'Please check each item that applies:',
      help: '',
      type: 'checkboxgroup',
      init: {
        placeholder: ' ',
        options: status
      },
      reqs: '',
      show: true
    },
    
    vfm_status_other: {
      name: 'StatusOther',
      data: '',
      label: 'Other (please specify):',
      help: '',
      type: 'text',
      init: {
        placeholder: ' ',
        options: status
      },
      reqs: '',
      show: true
    },
    
    vfm_support: {
      name: 'Support',
      data: '',
      label: 'Please list the names, addresses and phone numbers of each of your current physicians, therapists, counselors or other support services providers below. Indicate the person\'s role:',
      help: 'e.g. Mary Smith, Speech Therapist, 123 East 4th St, Rapid City 555-6789',
      type: 'textarea',
      init: {
        placeholder: ' ',
        options: ''
      },
      reqs: '',
      show: true
    },
    
    vfm_vrs: {
      name: 'VRS',
      data: '',
      label: 'Do you receive assistance from Vocational Rehabilitation Services? ',
      help: '',
      type: 'radio',
      init: {
        placeholder: ' ',
        options: options.yn
      },
      ctrl: [{
        opener: options.yn[0],
        targets: ['vfm_vrs_detail']
      }],
      reqs: 'required',
      show: true
    },
    
    vfm_vrs_detail: {
      name: 'VRSDetail',
      data: '',
      label: ' Please indicate the name, address, and phone number of your VRISVI Counselor',
      help: '',
      type: 'textarea',
      init: {
        placeholder: ' ',
        options: ''
      },
      reqs: '',
      show: false
    },
    
    vfm_condition: {
      name: 'Condition',
      data: [],
      // section_header: '2. List your summer classes, start dates, and credits:',
      // group: 'start',
      // group_label: 'Class 1',
      label: 'Disability Type:',
      help: 'Check all that apply',
      type: 'checkboxgroup',
      init: {
        placeholder: ' ',
        options: conditions
      },
      reqs: '',
      show: true
    },
    
    vfm_condition_other: {
      name: 'ConditionOther',
      data: '',
      label: 'Other Condition (please describe):',
      help: '',
      type: 'textarea',
      init: {
        placeholder: ' ',
        options: ''
      },
      reqs: '',
      show: true
    },
    
    vfm_impact: {
      name: 'Impact',
      data: '',
      label: 'How does your disability impact your ability to function in an academic setting?',
      help: 'Please be as specific as possible.',
      type: 'textarea',
      init: {
        placeholder: ' ',
        options: ''
      },
      reqs: '',
      show: true
    },
    
    vfm_equipment: {
      name: 'Equipment',
      data: [],
      // section_header: '2. List your summer classes, start dates, and credits:',
      // group: 'start',
      // group_label: 'Class 1',
      data: '',
      label: 'List all adaptive equipment you use on a regular basis.',
      help: '(e.g., magnification equipment, assistive speech device, power wheelchair, etc.',
      type: 'textarea',
      init: {
        placeholder: ' ',
        options: ''
      },
      reqs: '',
      show: true
    },
    
    vfm_residence: {
      name: 'Residence',
      data: '',
      // section_header: '2. List your summer classes, start dates, and credits:',
      // group: 'start',
      // group_label: 'Class 1',
      label: 'Where will/do you reside during the school semester?',
      help: '',
      type: 'radio',
      init: {
        placeholder: ' ',
        options: reside
      },
      reqs: 'required',
      show: true
    },
    
    vfm_services: {
      name: 'Services',
      data: [],
      // section_header: '2. List your summer classes, start dates, and credits:',
      // group: 'start',
      // group_label: 'Class 1',
      label: 'Check all of the services you think you may need:',
      help: 'Check all that apply.  Please note: Not all adaptations may be available at SDSM&T at this time.',
      type: 'checkboxgroup',
      init: {
        placeholder: ' ',
        options: services
      },
      reqs: '',
      show: true
    },
    
    vfm_services_other: {
      name: 'ServicesOther',
      data: '',
      label: 'Other Services (please describe):',
      help: '',
      type: 'textarea',
      init: {
        placeholder: ' ',
        options: ''
      },
      reqs: '',
      show: true
    },
  }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vfm/form-specs.js
// module id = null
// module chunks = 